import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CanEditService {
  get canEditTeam() {
    return [
      'Smack, Austen',
      'Vanali, Pedro',
      'Vanali, Pedro /CS',
      'Ferreira, Leonardo',
      'Santos, Pedro',
      'Silva, Carlos Eduardo',
      'Ferreira, Leonardo /CS',
      'Santos, Pedro /CS',
      'Silva, Carlos Eduardo /CS',
    ];
  }
}
